import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Logs from 'pages/SuperAdmin/Logs/Logs';

const SuperAdminLogsRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={Logs} />
      <Route path="/logs" component={SuperAdminLogsRouter} />
    </Switch>
  );
};

export default SuperAdminLogsRouter;
